// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"62rPl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _logger = require("@mediajel/tracker-core/logger");
var _loggerDefault = parcelHelpers.interopDefault(_logger);
var _snowplow = require("@mediajel/tracker-core/snowplow");
var _extensions = require("@mediajel/tracker-core/snowplow/extensions");
var _ensureBasketItemsOrderId = require("@mediajel/tracker-core/snowplow/extensions/ensure-basket-items-order-id");
var _ensureBasketItemsOrderIdDefault = parcelHelpers.interopDefault(_ensureBasketItemsOrderId);
var _registerThirdPartyTags = require("@mediajel/tracker-core/snowplow/extensions/register-third-party-tags");
var _registerThirdPartyTagsDefault = parcelHelpers.interopDefault(_registerThirdPartyTags);
const loadAdapters = async (context)=>{
    var _context_plugin, _tracker_ecommerce, _tracker_ecommerce1, _tracker_ecommerce2;
    const plugins = (context === null || context === void 0 ? void 0 : (_context_plugin = context.plugin) === null || _context_plugin === void 0 ? void 0 : _context_plugin.split(",")) || [];
    const data = "default"; // Test CI, remove this later
    (0, _loggerDefault.default).debug("Adapter Context", context);
    const snowplow = await (0, _snowplow.createSnowplowTracker)(context);
    // Apply extensions to the tracker
    const tracker = (0, _extensions.applyExtensions)(snowplow, [
        (0, _extensions.withDeduplicationExtension),
        (0, _ensureBasketItemsOrderIdDefault.default),
        (0, _registerThirdPartyTagsDefault.default),
        (0, _extensions.withSnowplowSegmentsExtension),
        /** Dynamically add Google Ads plugin/extension */ plugins.includes("googleAds") && await require("f8637153685ca98a").then(({ withGoogleAdsExtension })=>withGoogleAdsExtension),
        /** Dynamically add Bing Ads plugin/extension */ plugins.includes("bingAds") && await require("f8637153685ca98a").then(({ withBingAdsExtension })=>withBingAdsExtension)
    ]);
    var _tracker_ecommerce_trackTransaction;
    window.trackTrans = (_tracker_ecommerce_trackTransaction = (_tracker_ecommerce = tracker.ecommerce) === null || _tracker_ecommerce === void 0 ? void 0 : _tracker_ecommerce.trackTransaction) !== null && _tracker_ecommerce_trackTransaction !== void 0 ? _tracker_ecommerce_trackTransaction : ()=>{};
    window.trackSignUp = tracker.trackSignup;
    var _tracker_ecommerce_trackAddToCart;
    window.addToCart = (_tracker_ecommerce_trackAddToCart = (_tracker_ecommerce1 = tracker.ecommerce) === null || _tracker_ecommerce1 === void 0 ? void 0 : _tracker_ecommerce1.trackAddToCart) !== null && _tracker_ecommerce_trackAddToCart !== void 0 ? _tracker_ecommerce_trackAddToCart : ()=>{};
    var _tracker_ecommerce_trackRemoveFromCart;
    window.removeFromCart = (_tracker_ecommerce_trackRemoveFromCart = (_tracker_ecommerce2 = tracker.ecommerce) === null || _tracker_ecommerce2 === void 0 ? void 0 : _tracker_ecommerce2.trackRemoveFromCart) !== null && _tracker_ecommerce_trackRemoveFromCart !== void 0 ? _tracker_ecommerce_trackRemoveFromCart : ()=>{};
    switch(context.event){
        case "transaction":
            require("2dac2d880e1ed023").then(({ default: load })=>load(tracker));
            break;
        case "impression":
            require("e916a81d6d475005").then(({ default: load })=>load(tracker));
            break;
        case "signup":
            tracker.trackSignup(context);
            break;
        default:
            if (!context.environment) {
                (0, _loggerDefault.default).warn("No event/environment specified, Only pageview is active");
                return;
            }
            require("2dac2d880e1ed023").then(({ default: load })=>load(tracker));
            (0, _loggerDefault.default).warn(`No event specified, Loading ${context.environment}`);
    }
};
exports.default = loadAdapters;

},{"@mediajel/tracker-core/logger":"1YoS6","@mediajel/tracker-core/snowplow":"iJ7sC","@mediajel/tracker-core/snowplow/extensions":"2D72Y","@mediajel/tracker-core/snowplow/extensions/ensure-basket-items-order-id":"cS79W","@mediajel/tracker-core/snowplow/extensions/register-third-party-tags":"a79c7","f8637153685ca98a":"2p0Rx","2dac2d880e1ed023":"eGb6Q","e916a81d6d475005":"ey0FQ","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"iJ7sC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSnowplowTracker", ()=>(0, _trackerDefault.default));
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _tracker = require("./tracker");
var _trackerDefault = parcelHelpers.interopDefault(_tracker);

},{"./types":"cTWxZ","./tracker":"fl4p5","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"cTWxZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransactionEvent", ()=>(0, _types.TransactionEvent));
parcelHelpers.export(exports, "CartEvent", ()=>(0, _types.CartEvent));
parcelHelpers.export(exports, "SignupParams", ()=>(0, _types.SignupParams));
var _types = require("@mediajel/tracker-core/types");

},{"@mediajel/tracker-core/types":"kctaX","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"kctaX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"fl4p5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _logger = require("@mediajel/tracker-core/logger");
var _loggerDefault = parcelHelpers.interopDefault(_logger);
// Dynamic imports keep the tag lean on client sites — only the tracker version actually used is
// downloaded. IMPORTANT: use the PACKAGE-SPECIFIER form (@mediajel/tracker-core/...), not a relative
// path. A relative import() inside a Bun-symlinked workspace package resolves to a different
// canonical path than the package-`exports` resolution, so Parcel registers the chunk under one
// module id and looks it up under another → the import resolves to `undefined`. The package
// specifier matches the static imports elsewhere, so resolution stays consistent and it code-splits.
const createSnowplowTracker = async (input)=>{
    const { appId, collector, event } = input;
    (0, _loggerDefault.default).info(`Creating Snowplow tracker for version ${input.version}`);
    const isLegacyTracker = input.version === "1";
    const { default: createTracker } = isLegacyTracker ? await require("30c140432d7b3194") : await require("565f19b78a3805ac");
    const tracker = await createTracker(input);
    tracker.initialize({
        appId,
        collector,
        event
    });
    tracker.record(input);
    return tracker;
};
exports.default = createSnowplowTracker;

},{"@mediajel/tracker-core/logger":"1YoS6","30c140432d7b3194":"i4gHa","565f19b78a3805ac":"eTulE","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"i4gHa":[function(require,module,exports) {
module.exports = require("3e1bbe612ae9b2cb")(require("12d481d045fe7953").resolve("anwQo")).then(()=>module.bundle.root("kSBA7"));

},{"3e1bbe612ae9b2cb":"auCaP","12d481d045fe7953":"cH4oS"}],"eTulE":[function(require,module,exports) {
module.exports = require("3a8e113513f42e4c")(require("fef175d1fdf78a79").resolve("8VFOy")).then(()=>module.bundle.root("bzesF"));

},{"3a8e113513f42e4c":"auCaP","fef175d1fdf78a79":"cH4oS"}],"2D72Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withSnowplowSegmentsExtension", ()=>(0, _segmentsDefault.default));
parcelHelpers.export(exports, "withGoogleAdsExtension", ()=>(0, _googleAdsDefault.default));
parcelHelpers.export(exports, "withBingAdsExtension", ()=>(0, _bingAdsDefault.default));
parcelHelpers.export(exports, "withDeduplicationExtension", ()=>(0, _deduplicatorDefault.default));
parcelHelpers.export(exports, "applyExtensions", ()=>applyExtensions);
var _segments = require("./segments");
var _segmentsDefault = parcelHelpers.interopDefault(_segments);
var _googleAds = require("./google-ads");
var _googleAdsDefault = parcelHelpers.interopDefault(_googleAds);
var _bingAds = require("./bing-ads");
var _bingAdsDefault = parcelHelpers.interopDefault(_bingAds);
var _deduplicator = require("./deduplicator");
var _deduplicatorDefault = parcelHelpers.interopDefault(_deduplicator);
const applyExtensions = (tracker, // Either load a function, false, or undefined for dynamic loading
extensions)=>{
    if (!extensions) return tracker;
    return extensions.reduce((currentTracker, extension)=>extension ? extension(currentTracker) : currentTracker, tracker);
};

},{"./segments":"lAIbU","./google-ads":"2kiJO","./bing-ads":"5PWHS","./deduplicator":"gowHL","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"lAIbU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _segmentBuilder = require("@mediajel/tracker-core/segment-builder");
const setupExtension = (context)=>{
    const liquidm = context.segmentId || context.s1;
    //* If s2.pv or s2.tr is not present, use context.s2 as default
    //* mainly used for legacy purposes
    const nexxen = {
        pageVisitorBeaconId: context["s2.pv"] || context["s2"],
        transactionBeaconId: context["s2.tr"] || context["s2"]
    };
    const dstillery = {
        siteVisitorNC: context["s3.pv"] || context["s3"],
        purchaseNC: context["s3.tr"] || context["s3"]
    };
    const segments = (0, _segmentBuilder.createSegments)({
        //* Accept both segmentId and s1 for legacy purposes
        liquidm,
        nexxen,
        dstillery
    });
    //* Expose cnnaSegments to the window object for custom integrations to use
    window.cnnaSegments = segments;
    liquidm && segments.liquidm.emit();
    nexxen && segments.nexxen.emit();
    dstillery && segments.dstillery.emit();
    return segments;
};
/**
 * This extension will send transaction events to our partner segments when a transaction is tracked
 */ const withSnowplowSegmentsExtension = (snowplow)=>{
    const segments = setupExtension(snowplow.context);
    if (!snowplow.ecommerce) return snowplow;
    // Original trackTransaction method
    const trackTransaction = snowplow.ecommerce.trackTransaction;
    //* Override the trackTransaction method
    snowplow.ecommerce.trackTransaction = (input)=>{
        trackTransaction(input);
        segments.nexxen.emitPurchase({
            bprice: input.total,
            cid: input.id
        });
        segments.dstillery.emitPurchase({
            amount: input.total,
            orderId: input.id
        });
    };
    return snowplow;
};
exports.default = withSnowplowSegmentsExtension;

},{"@mediajel/tracker-core/segment-builder":"IHbV3","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"IHbV3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSegments", ()=>(0, _builderDefault.default));
var _builder = require("./builder");
var _builderDefault = parcelHelpers.interopDefault(_builder);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./builder":"kQv4z","./types":"4H6Zz","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"kQv4z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _liquidm = require("@mediajel/tracker-core/segment-builder/segments/liquidm");
var _liquidmDefault = parcelHelpers.interopDefault(_liquidm);
var _nexxen = require("@mediajel/tracker-core/segment-builder/segments/nexxen");
var _nexxenDefault = parcelHelpers.interopDefault(_nexxen);
var _dstillery = require("@mediajel/tracker-core/segment-builder/segments/dstillery");
var _dstilleryDefault = parcelHelpers.interopDefault(_dstillery);
const createSegments = (input)=>{
    const { liquidm, nexxen, dstillery } = input;
    return {
        nexxen: (0, _nexxenDefault.default)(nexxen),
        liquidm: (0, _liquidmDefault.default)(liquidm),
        dstillery: (0, _dstilleryDefault.default)(dstillery)
    };
};
exports.default = createSegments;

},{"@mediajel/tracker-core/segment-builder/segments/liquidm":"qDG9k","@mediajel/tracker-core/segment-builder/segments/nexxen":"j58jQ","@mediajel/tracker-core/segment-builder/segments/dstillery":"hAcSc","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"qDG9k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _logger = require("@mediajel/tracker-core/logger");
var _loggerDefault = parcelHelpers.interopDefault(_logger);
const liquidmSegmentBuilder = (segmentId)=>{
    return {
        emit: ()=>{
            (0, _loggerDefault.default).info("Building s1 segment with segmentId: ", segmentId);
            (function(c, d) {
                var _b_parentNode;
                var a = document.createElement("script");
                a.type = "text/javascript";
                a.async = !0;
                a.src = `https://tracking.lqm.io/odin/handle_sync.js?seg=${segmentId}&gdpr=` + ("1" === c ? "1" : "0") + "&gdpr_consent=" + (d ? encodeURIComponent(d) : "") + "&cb=" + new Date().getTime();
                var b = document.getElementsByTagName("script")[0];
                (_b_parentNode = b.parentNode) === null || _b_parentNode === void 0 ? void 0 : _b_parentNode.insertBefore(a, b);
            })();
        }
    };
};
exports.default = liquidmSegmentBuilder;

},{"@mediajel/tracker-core/logger":"1YoS6","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"j58jQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _logger = require("@mediajel/tracker-core/logger");
var _loggerDefault = parcelHelpers.interopDefault(_logger);
var _createImagePixel = require("@mediajel/tracker-core/utils/create-image-pixel");
var _createImagePixelDefault = parcelHelpers.interopDefault(_createImagePixel);
const nexxenSegmentBuilder = (beacons)=>{
    const { pageVisitorBeaconId, transactionBeaconId } = beacons;
    return {
        emit: ()=>{
            if (!pageVisitorBeaconId) return;
            (0, _loggerDefault.default).info("Building s2 segment with segmentId: ", pageVisitorBeaconId);
            const pix = (0, _createImagePixelDefault.default)(`https://r.turn.com/r/beacon?b2=${pageVisitorBeaconId}`);
            document.head.appendChild(pix);
        },
        emitPurchase: (input)=>{
            const { cid, bprice } = input;
            if (!cid || !bprice || !transactionBeaconId) {
                (0, _loggerDefault.default).warn("Missing required data for s2.tr");
                return;
            }
            (0, _loggerDefault.default).info("Emitting purchase event for segmentId: ", transactionBeaconId);
            const pix = (0, _createImagePixelDefault.default)(`https://r.turn.com/r/beacon?b2=${transactionBeaconId}&cid=${cid}&bprice=${bprice}`);
            document.head.appendChild(pix);
        }
    };
};
exports.default = nexxenSegmentBuilder;

},{"@mediajel/tracker-core/logger":"1YoS6","@mediajel/tracker-core/utils/create-image-pixel":"6YXoQ","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"6YXoQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const createImagePixel = (url)=>{
    const pixel = document.createElement("img");
    pixel.src = url;
    // Ensure it's 1x1 pixel in size
    pixel.width = 1;
    pixel.height = 1;
    // Make it invisible
    pixel.style.position = "absolute";
    pixel.style.left = "-9999px";
    return pixel;
};
exports.default = createImagePixel;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"hAcSc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _logger = require("@mediajel/tracker-core/logger");
var _loggerDefault = parcelHelpers.interopDefault(_logger);
var _createImagePixel = require("@mediajel/tracker-core/utils/create-image-pixel");
var _createImagePixelDefault = parcelHelpers.interopDefault(_createImagePixel);
const DstillerySegmentBuilderInput = (input)=>{
    const { siteVisitorNC, purchaseNC } = input;
    return {
        emit: ()=>{
            if (!siteVisitorNC) return;
            (0, _loggerDefault.default).info("Building s3 segment with segmentId: ", siteVisitorNC);
            const pix = (0, _createImagePixelDefault.default)(`https://action.dstillery.com/orbserv/nsjs?adv=cl172365597545365&ns=8779&nc=${siteVisitorNC}&ncv=76`);
            document.head.appendChild(pix);
        },
        emitPurchase: (input)=>{
            const { orderId, amount } = input;
            if (!orderId || !amount || !purchaseNC) {
                (0, _loggerDefault.default).warn("Missing required data for s3.tr");
                return;
            }
            (0, _loggerDefault.default).info("Emitting dstillery purchase event for segmentId: ", purchaseNC);
            const pix = (0, _createImagePixelDefault.default)(`https://action.dstillery.com/orbserv/nsjs?adv=cl172365597545365&ns=8779&nc=${purchaseNC}&ncv=76&dstOrderId=${orderId}&dstOrderAmount=${amount}`);
            document.head.appendChild(pix);
        }
    };
};
exports.default = DstillerySegmentBuilderInput;

},{"@mediajel/tracker-core/logger":"1YoS6","@mediajel/tracker-core/utils/create-image-pixel":"6YXoQ","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"4H6Zz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"2kiJO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _logger = require("@mediajel/tracker-core/logger");
var _loggerDefault = parcelHelpers.interopDefault(_logger);
const setupExtension = (context)=>{
    // Fail fast if the required params are not present
    if (!context.conversionId || !context.conversionLabel) (0, _loggerDefault.default).warn("Conversion ID and Conversion Label are required for Google Ads");
    if (!context.conversionId.includes("AW-")) context.conversionId = `AW-${context.conversionId}`;
    (0, _loggerDefault.default).info(`\u{1F680}\u{1F680}\u{1F680} Google Ads Plugin loaded for ${context.environment}`);
    document.createElement("script").src = `https://www.googletagmanager.com/gtag/js?id=${context.conversionId}`;
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        (window.dataLayer = window.dataLayer || []).push(arguments);
    }
    window.gtag = gtag;
    /**Note: the @ts-ignore lines below are necessary to supress typescript warnings for the arguments object above */ // @ts-ignore
    gtag("js", new Date());
    // @ts-ignore
    gtag("config", context.conversionId);
    // Cross domain tracking
    if (context.crossDomainSites) {
        const crossDomainSites = context.crossDomainSites.split(",");
        const sites = crossDomainSites.map((site)=>site.trim());
        // @ts-ignore
        gtag("set", "linker", {
            domains: sites
        });
    }
};
/**
 * This extension will send Google ads conversion events when a transaction is tracked
 */ const withSnowplowGoogleAdsExtension = (snowplow)=>{
    let { conversionId, conversionLabel } = snowplow.context;
    if (!conversionId.includes("AW-")) conversionId = `AW-${conversionId}`;
    setupExtension(snowplow.context);
    if (!snowplow.ecommerce) return snowplow;
    // Original trackTransaction method
    const trackTransaction = snowplow.ecommerce.trackTransaction;
    //* Override the trackTransaction method
    snowplow.ecommerce.trackTransaction = (input)=>{
        var _window_gtag, _window;
        trackTransaction(input);
        (0, _loggerDefault.default).info(`\u{1F680}\u{1F680}\u{1F680} Google Ads Extension Transaction Event`, {
            send_to: `${conversionId}/${conversionLabel}`,
            value: input.total,
            currency: input.currency,
            transaction_id: input.id
        });
        (_window_gtag = (_window = window).gtag) === null || _window_gtag === void 0 ? void 0 : _window_gtag.call(_window, "event", "conversion", {
            send_to: `${conversionId}/${conversionLabel}`,
            value: input.total,
            currency: input.currency,
            transaction_id: input.id
        });
    };
    return snowplow;
};
exports.default = withSnowplowGoogleAdsExtension;

},{"@mediajel/tracker-core/logger":"1YoS6","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"5PWHS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _logger = require("@mediajel/tracker-core/logger");
var _loggerDefault = parcelHelpers.interopDefault(_logger);
const setupExtension = (context)=>{
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.innerHTML = `(function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:${context.tagId}};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");`;
    document.head.appendChild(script);
    window.uetq = window.uetq || [];
};
/**
 * This extension will send Bing Ads conversion events when a transaction is tracked
 */ const withSnowplowBingAdsExtension = (snowplow)=>{
    setupExtension(snowplow.context);
    if (!snowplow.ecommerce) return snowplow;
    // Original trackTransaction method
    const trackTransaction = snowplow.ecommerce.trackTransaction;
    //* Override the trackTransaction method
    snowplow.ecommerce.trackTransaction = (input)=>{
        var _window_uetq;
        trackTransaction(input);
        (0, _loggerDefault.default).info(`\u{1F680}\u{1F680}\u{1F680} Bing Ads Extension Transaction Event`, {
            transaction_id: input.id,
            ecomm_prodid: input.items.map((item)=>item.sku),
            ecomm_pagetype: "purchase",
            ecomm_totalvalue: input.total,
            revenue_value: input.total,
            currency: "USD",
            items: input.items.map((item)=>({
                    id: item.sku,
                    quantity: item.quantity,
                    price: item.unitPrice
                }))
        });
        (_window_uetq = window.uetq) === null || _window_uetq === void 0 ? void 0 : _window_uetq.push("event", "purchase", {
            transaction_id: input.id,
            ecomm_prodid: input.items.map((item)=>item.sku),
            ecomm_pagetype: "purchase",
            ecomm_totalvalue: input.total,
            revenue_value: input.total,
            currency: "USD",
            items: input.items.map((item)=>({
                    id: item.sku,
                    quantity: item.quantity,
                    price: item.unitPrice
                }))
        });
    };
    return snowplow;
};
exports.default = withSnowplowBingAdsExtension;

},{"@mediajel/tracker-core/logger":"1YoS6","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"gowHL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _logger = require("@mediajel/tracker-core/logger");
// add a check to check if the jsonString is an array
function tryParseJSONObject(jsonString) {
    try {
        var o = JSON.parse(jsonString);
        if (o && typeof o === "object") return {
            type: "object",
            value: o
        };
        if (Array.isArray(o)) return {
            type: "array",
            value: o
        };
        return {
            type: "string",
            value: jsonString
        };
    } catch (e) {
        return {
            type: "string",
            value: jsonString
        };
    }
}
const withDeduplicationExtension = (snowplow)=>{
    const logger = (0, _logger.createLogger)("MJ:Deduplication");
    if (!snowplow.ecommerce) return snowplow;
    const { trackTransaction: originalTrackTransaction, trackAddToCart: originalTrackAddToCart, trackRemoveFromCart: originalTrackRemoveFromCart } = snowplow.ecommerce;
    const { trackSignup: originalTrackSignup } = snowplow;
    const getStorageKey = (eventType)=>`${snowplow.context.appId}_${eventType}`;
    const deduplicateEvent = (originalMethod, eventType, input, idField)=>{
        const storageKey = getStorageKey(eventType);
        const eventId = idField.map((key)=>input[key]).join(":");
        let value = localStorage.getItem(storageKey);
        let existingIds = [];
        if (value) {
            const parsed = tryParseJSONObject(value);
            if ((parsed === null || parsed === void 0 ? void 0 : parsed.type) === "object") existingIds = parsed.value;
            else if ((parsed === null || parsed === void 0 ? void 0 : parsed.type) === "string") existingIds = [
                parsed.value
            ];
        }
        logger.debug("existingIds", existingIds);
        if (existingIds.includes(eventId)) {
            logger.warn(`${eventType} with id ${eventId} already tracked. Discarding duplicate.`);
            return;
        }
        originalMethod(input);
        localStorage.setItem(storageKey, JSON.stringify([
            ...existingIds,
            eventId
        ]));
    };
    snowplow.ecommerce.trackTransaction = (input)=>deduplicateEvent(originalTrackTransaction, "transaction", input, [
            "id"
        ]);
    snowplow.ecommerce.trackAddToCart = (input)=>deduplicateEvent(originalTrackAddToCart, "addToCart", input, [
            "name",
            "quantity"
        ]);
    snowplow.ecommerce.trackRemoveFromCart = (input)=>deduplicateEvent(originalTrackRemoveFromCart, "removeFromCart", input, [
            "name",
            "quantity"
        ]);
    snowplow.trackSignup = (input)=>deduplicateEvent(originalTrackSignup, "signUp", input, [
            "uuid",
            "emailAddress"
        ]);
    return snowplow;
};
exports.default = withDeduplicationExtension;

},{"@mediajel/tracker-core/logger":"1YoS6","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"cS79W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *
 * This extension ensures that the orderId for the basket items is the same as the orderId for the transaction.
 * This is important for Shopify integrations since the orderId for the basket items is the product id and not the order id.
 */ const withEnsureBasketItemsOrderId = (snowplow)=>{
    if (!snowplow.ecommerce) return snowplow;
    const trackTransaction = snowplow.ecommerce.trackTransaction;
    snowplow.ecommerce.trackTransaction = (input)=>{
        trackTransaction({
            id: input.id,
            affiliateId: input.affiliateId,
            total: input.total,
            tax: input.tax,
            shipping: input.shipping,
            city: input.city,
            state: input.state,
            country: input.country,
            currency: input.currency,
            discount: input.discount,
            couponCode: input.couponCode,
            alternativeTransactionIds: input.alternativeTransactionIds,
            items: input.items.map((item)=>({
                    orderId: input.id,
                    sku: item.sku,
                    name: item.name,
                    category: item.category,
                    unitPrice: item.unitPrice,
                    quantity: item.quantity,
                    currency: item.currency
                }))
        });
    };
    return snowplow;
};
exports.default = withEnsureBasketItemsOrderId;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"a79c7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let thirdPartyTags = {};
const registerThirdPartyTags = (input)=>{
    thirdPartyTags = input;
};
window.registerThirdPartyTags = registerThirdPartyTags;
const replaceMacros = (tag, placeholders)=>tag.replace(/{\w+}/g, (match)=>placeholders[match] || match);
const createElementForTag = (type, tagWithMacros)=>{
    if (type === "script") {
        const script = document.createElement("script");
        script.src = tagWithMacros;
        script.async = true;
        document.body.appendChild(script);
    } else if (type === "image") {
        const img = new Image();
        img.src = tagWithMacros;
        document.body.appendChild(img);
    }
};
const processTags = (tags, placeholders)=>{
    tags === null || tags === void 0 ? void 0 : tags.forEach(({ tag, type })=>{
        const tagWithMacros = replaceMacros(tag, placeholders);
        createElementForTag(type, tagWithMacros);
    });
};
const withRegisterThirdPartyTagsExtension = (snowplow)=>{
    if (!snowplow.ecommerce) return snowplow;
    const { trackTransaction, trackAddToCart, trackRemoveFromCart } = snowplow.ecommerce;
    const { trackSignup } = snowplow;
    snowplow.ecommerce.trackTransaction = (input)=>{
        var _input_id, _input_total, _input_tax, _input_shipping, _input_userId;
        trackTransaction(input);
        var _thirdPartyTags_onTransaction;
        processTags((_thirdPartyTags_onTransaction = thirdPartyTags.onTransaction) !== null && _thirdPartyTags_onTransaction !== void 0 ? _thirdPartyTags_onTransaction : [], {
            "{transaction_id}": (input === null || input === void 0 ? void 0 : (_input_id = input.id) === null || _input_id === void 0 ? void 0 : _input_id.toString()) || "null",
            "{transaction_total}": (input === null || input === void 0 ? void 0 : (_input_total = input.total) === null || _input_total === void 0 ? void 0 : _input_total.toString()) || "0",
            "{transaction_tax}": (input === null || input === void 0 ? void 0 : (_input_tax = input.tax) === null || _input_tax === void 0 ? void 0 : _input_tax.toString()) || "0",
            "{transaction_shipping}": (input === null || input === void 0 ? void 0 : (_input_shipping = input.shipping) === null || _input_shipping === void 0 ? void 0 : _input_shipping.toString()) || "0",
            "{transaction_city}": (input === null || input === void 0 ? void 0 : input.city) || "null",
            "{transaction_state}": (input === null || input === void 0 ? void 0 : input.state) || "null",
            "{transaction_country}": (input === null || input === void 0 ? void 0 : input.country) || "null",
            "{transaction_currency}": (input === null || input === void 0 ? void 0 : input.currency) || "null",
            "{transaction_userId}": (input === null || input === void 0 ? void 0 : (_input_userId = input.userId) === null || _input_userId === void 0 ? void 0 : _input_userId.toString()) || "null"
        });
    };
    snowplow.ecommerce.trackAddToCart = (input)=>{
        var _input_unitPrice, _input_quantity, _input_userId;
        trackAddToCart(input);
        var _thirdPartyTags_onAddToCart;
        processTags((_thirdPartyTags_onAddToCart = thirdPartyTags.onAddToCart) !== null && _thirdPartyTags_onAddToCart !== void 0 ? _thirdPartyTags_onAddToCart : [], {
            "{cart_id}": (input === null || input === void 0 ? void 0 : input.sku) || "null",
            "{cart_name}": (input === null || input === void 0 ? void 0 : input.name) || "null",
            "{cart_category}": (input === null || input === void 0 ? void 0 : input.category) || "null",
            "{cart_unitPrice}": (input === null || input === void 0 ? void 0 : (_input_unitPrice = input.unitPrice) === null || _input_unitPrice === void 0 ? void 0 : _input_unitPrice.toString()) || "0",
            "{cart_quantity}": (input === null || input === void 0 ? void 0 : (_input_quantity = input.quantity) === null || _input_quantity === void 0 ? void 0 : _input_quantity.toString()) || "0",
            "{cart_currency}": (input === null || input === void 0 ? void 0 : input.currency) || "null",
            "{cart_userId}": (input === null || input === void 0 ? void 0 : (_input_userId = input.userId) === null || _input_userId === void 0 ? void 0 : _input_userId.toString()) || "null"
        });
    };
    snowplow.ecommerce.trackRemoveFromCart = (input)=>{
        var _input_unitPrice, _input_quantity, _input_userId;
        trackRemoveFromCart(input);
        var _thirdPartyTags_onRemoveFromCart;
        processTags((_thirdPartyTags_onRemoveFromCart = thirdPartyTags.onRemoveFromCart) !== null && _thirdPartyTags_onRemoveFromCart !== void 0 ? _thirdPartyTags_onRemoveFromCart : [], {
            "{cart_id}": (input === null || input === void 0 ? void 0 : input.sku) || "null",
            "{cart_name}": (input === null || input === void 0 ? void 0 : input.name) || "null",
            "{cart_category}": (input === null || input === void 0 ? void 0 : input.category) || "null",
            "{cart_unitPrice}": (input === null || input === void 0 ? void 0 : (_input_unitPrice = input.unitPrice) === null || _input_unitPrice === void 0 ? void 0 : _input_unitPrice.toString()) || "0",
            "{cart_quantity}": (input === null || input === void 0 ? void 0 : (_input_quantity = input.quantity) === null || _input_quantity === void 0 ? void 0 : _input_quantity.toString()) || "0",
            "{cart_currency}": (input === null || input === void 0 ? void 0 : input.currency) || "null",
            "{cart_userId}": (input === null || input === void 0 ? void 0 : (_input_userId = input.userId) === null || _input_userId === void 0 ? void 0 : _input_userId.toString()) || "null"
        });
    };
    snowplow.trackSignup = (input)=>{
        trackSignup(input);
        var _thirdPartyTags_onSignup;
        processTags((_thirdPartyTags_onSignup = thirdPartyTags.onSignup) !== null && _thirdPartyTags_onSignup !== void 0 ? _thirdPartyTags_onSignup : [], {
            "{signup_firstName}": (input === null || input === void 0 ? void 0 : input.firstName) || "null",
            "{signup_lastName}": (input === null || input === void 0 ? void 0 : input.lastName) || "null",
            "{signup_uuid}": (input === null || input === void 0 ? void 0 : input.uuid) || "null",
            "{signup_email}": (input === null || input === void 0 ? void 0 : input.emailAddress) || "null",
            "{signup_address}": (input === null || input === void 0 ? void 0 : input.address) || "null",
            "{signup_city}": (input === null || input === void 0 ? void 0 : input.city) || "null",
            "{signup_state}": (input === null || input === void 0 ? void 0 : input.state) || "null",
            "{signup_phone}": (input === null || input === void 0 ? void 0 : input.phoneNumber) || "null",
            "{signup_advertiser}": (input === null || input === void 0 ? void 0 : input.advertiser) || "null"
        });
    };
    return snowplow;
};
exports.default = withRegisterThirdPartyTagsExtension;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"2p0Rx":[function(require,module,exports) {
module.exports = Promise.resolve(module.bundle.root("2D72Y"));

},{}],"eGb6Q":[function(require,module,exports) {
module.exports = require("f44f93c8f8e2adf5")(require("745811d11c3cff03").resolve("21vB7")).then(()=>module.bundle.root("3HlAJ"));

},{"f44f93c8f8e2adf5":"auCaP","745811d11c3cff03":"cH4oS"}],"ey0FQ":[function(require,module,exports) {
module.exports = require("c5fadc889591b651")(require("5d180181bd0cb328").resolve("kzDx5")).then(()=>module.bundle.root("aZ3CI"));

},{"c5fadc889591b651":"auCaP","5d180181bd0cb328":"cH4oS"}]},[], null, "parcelRequire07df")

//# sourceMappingURL=adapters.f9e65a28.js.map
